/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Type_FunicularInputs */

const fr_vehicle_type_funicular = /** @type {(inputs: Vehicle_Type_FunicularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funiculaire`)
};

const en_vehicle_type_funicular = /** @type {(inputs: Vehicle_Type_FunicularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funicular`)
};

/**
* | output |
* | --- |
* | "Funicular" |
*
* @param {Vehicle_Type_FunicularInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_type_funicular = /** @type {((inputs?: Vehicle_Type_FunicularInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Type_FunicularInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_type_funicular(inputs)
	return en_vehicle_type_funicular(inputs)
});